<div class="retag">
    <header>
        <p>Retag</p>
        <div>
           <label class="toggle-switch">
                <input type="checkbox" (change)="onToggleCheckbox([EntityModelConfiguration.Retag])" [checked]="isChecked([EntityModelConfiguration.Retag])"/>
                <span class="switch-slider"></span>
            </label>
            <button>
                <img src="../../../../../assets/icons/pencil.svg" />
            </button>
            <button>
                <img src="../../../../../assets/icons/delete-trash-can.svg" />               
            </button>
        </div>
    </header>
    <div class="body">
        <label>        
            <input type="checkbox" (change)="onToggleCheckbox([EntityModelConfiguration.Retag])" [checked]="isChecked([EntityModelConfiguration.Retag])"/>
            <span>Field Agent</span>
        </label>
    </div>
</div>